export default "__VITE_ASSET__B_P8aZBB__"